import { Preloader } from "../components/Preloader.js";

class Ajax {
  // Request options
  //{
  //     method: 'POST', // *GET, POST, PUT, DELETE, etc.
  //     mode: 'cors', // no-cors, *cors, same-origin
  //     cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
  //     credentials: 'same-origin', // include, *same-origin, omit
  //     headers: {
  //       'Content-Type': 'application/json'
  //       // 'Content-Type': 'application/x-www-form-urlencoded',
  //     },
  //     redirect: 'follow', // manual, *follow, error
  //     referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
  //     body: JSON.stringify(data) // body data type must match "Content-Type" header
  //   }

  static async sendAjaxRequest(url = "", options = {}, bodyData = "", preloader = true) {
    // Pokazanie preloadera.
    if (preloader) {
      Preloader.show();
    }

    let response = await fetch(url, options);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    } else {
      if (preloader) {
        // Ukrycie preloadera.
        Preloader.hide();
      }
    }

    switch (bodyData) {
      case "ArrayBuffer":
        return await response.arrayBuffer();

      case "Blob":
        return await response.blob();

      case "String":
        return await response.text();

      case "URLSearchParams":
        return await response.json();

      case "FormData":
        return await response.formData();

      default:
        return await response.json();
    }
  }
}

export { Ajax };
